import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FocusInputType, KeyValueSetInt, LocalService, NumericConfig } from 'src/service/local.service';

@Component({
  selector: 'app-otp-pad',
  templateUrl: './otp-pad.component.html',
  styleUrls: ['./otp-pad.component.scss']
})
export class OtpPadComponent implements OnInit {
  @Input() otpLength: number = 6; @Input() autofocus: boolean = true; @Input() numericInputMode: boolean = true;
  @Output() onFill = new EventEmitter(); htmlId = ''; elementIds: any;
  items: KeyValueSetInt[] = []; allowedNumbers: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

  numericConfig: NumericConfig = { isDecimalAllowed: true, maxValue: 9 } as NumericConfig;

  constructor(public localService: LocalService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      otp_num: 'otp_num_' + this.htmlId + '_'
    };
  }

  ngOnInit(): void {
    this.onLoad();
  }

  onLoad() {
    for (let i = 0; i < this.otpLength; i++) {
      this.items.push({ key: null } as KeyValueSetInt);
    }
    this.onFocus(0);
  }

  onInput(event) {
    let currentFill = 0;
    if (event.target.value.length > 1) {
      this.items.forEach(x => x.key = null);
      let length = event.target.value.length;
      for (let i = 0; i < length; i++) {
        if (currentFill < this.otpLength) {
          let character = event.target.value[i];
          if (this.allowedNumbers.includes(character.toString())) {
            this.items[i].key = parseInt(character);
            currentFill++;
          }
        } else {
          break;
        }
      }
    }
    currentFill = this.items.filter(x => x.key != null).length;
    if (currentFill == this.otpLength) {
      let value = this.items.map(x => x.key.toString()).join("");
      this.onFill.emit(value);
    } else {
      this.onFocus(currentFill);
    }
  }

  onFocus(currentIndex, event = null) {
    let nextIndex = currentIndex;
    if (event) {
      switch (event.keyCode) {
        case 39: {//Right Arrow
          if (this.items[currentIndex - 1].key) {
            nextIndex = currentIndex + 1;
          }
        } break;
        case 37: {//Left Arrow
          nextIndex = currentIndex - 1;
        } break;
        case 8: {//Backspace
          if (!this.items[currentIndex - 1].key) {
            nextIndex = currentIndex - 1;
          }
        } break;
        case 46: {//Delete
          this.items.forEach(x => x.key = null);
          nextIndex = 1;
        } break;
        default: {
          if (this.items.length != this.items.filter(x => x.key == null).length && this.items[currentIndex - 1].key) {
            nextIndex = currentIndex + 1;
          }
        } break;
      }
    } else {
      nextIndex = currentIndex + 1;
    }
    this.localService.onFocusNextInput(this.elementIds.otp_num + (nextIndex), FocusInputType.TextBox, true);
  }

}
